import { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { useDomesticMarketSpreadPriceContext } from "./DomesticMarketSpreadPriceContext";
import { sendData } from "../../../lib/dashboard/actions";

const DomesticMarketSpreadPriceCategoryContext = createContext();

const DomesticMarketSpreadPriceCategoryProvider = ({ children }) => {
  const { setIsFavoritesModal } = useDomesticMarketSpreadPriceContext();

  const [inputCategoryValues1, setInputCategoryValues1] = useState({
    industry: null,
    field: null,
    group: null,
    company: null,
    commodity: null,
  });

  const [inputCategoryValues2, setInputCategoryValues2] = useState({
    industry: null,
    field: null,
    group: null,
    company: null,
    commodity: null,
  });

  const [categoryChartData, setCategoryChartData] = useState({
    data: [],
    isLoading: false,
  });

  const industries1 = useSWR("/domestic/category/industry", fetchData, {
    dedupingInterval: 1000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const fields1 = useSWR(
    inputCategoryValues1.industry
      ? `/domestic/category/field/${inputCategoryValues1.industry?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const groups1 = useSWR(
    inputCategoryValues1.field
      ? `/domestic/category/group/${inputCategoryValues1.field?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const companies1 = useSWR(
    inputCategoryValues1.group
      ? `/domestic/category/company/${inputCategoryValues1.group?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const commodities1 = useSWR(
    inputCategoryValues1.company
      ? `/domestic/category/commodity/${inputCategoryValues1.company?.id}/${inputCategoryValues1.group?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const industries2 = useSWR("/domestic/category/industry", fetchData, {
    dedupingInterval: 60 * 60 * 1000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const fields2 = useSWR(
    inputCategoryValues2.industry
      ? `/domestic/category/field/${inputCategoryValues2.industry?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const groups2 = useSWR(
    inputCategoryValues2.field
      ? `/domestic/category/group/${inputCategoryValues2.field?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const companies2 = useSWR(
    inputCategoryValues2.group
      ? `/domestic/category/company/${inputCategoryValues2.group?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const commodities2 = useSWR(
    inputCategoryValues2.company
      ? `/domestic/category/commodity/${inputCategoryValues2.company?.id}/${inputCategoryValues2.group?.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const handleShowChart = async (body) => {
    setCategoryChartData((prev) => ({ ...prev, isLoading: true }));
    const res = await sendData(body, "/domestic/category/ratio-chart");
    if (res.status === 200)
      setCategoryChartData({ isLoading: false, data: res.data });
    setCategoryChartData((prev) => ({ ...prev, isLoading: false }));
  };

  const handleSelectedCategoryFavorite = async (favorite) => {
    const {
      industry1,
      industry2,
      field1,
      field2,
      industry1_id,
      industry2_id,
      field1_id,
      field2_id,
      company1,
      company1_id,
      group1,
      group1_id,
      commodity1,
      commodity1_id,
      company2,
      company2_id,
      group2,
      group2_id,
      commodity2,
      commodity2_id,
    } = favorite;

    setInputCategoryValues1({
      industry: { id: industry1_id, name: industry1 },
      field: { id: field1_id, name: field1 },
      company: company1 && { id: company1_id, name: company1 },
      group: group1 && { id: group1_id, name: group1 },
      commodity: commodity1 && { id: commodity1_id, name: commodity1 },
    });

    setInputCategoryValues2({
      industry: { id: industry2_id, name: industry2 },
      field: { id: field2_id, name: field2 },
      company: company2 && { id: company2_id, name: company2 },
      group: group2 && { id: group2_id, name: group2 },
      commodity: commodity2 && { id: commodity2_id, name: commodity2 },
    });

    await handleShowChart({
      industry1_id,
      industry2_id,
      field1_id,
      field2_id,
      company1_id,
      group1_id,
      commodity1_id,
      company2_id,
      group2_id,
      commodity2_id,
    });

    setIsFavoritesModal(false);
  };
  return (
    <DomesticMarketSpreadPriceCategoryContext.Provider
      value={{
        handleShowChart,
        handleSelectedCategoryFavorite,
        categoryChartData: categoryChartData.data,
        isCategoryChartLoading: categoryChartData.isLoading,
        companies1,
        fields1,
        industries1,
        groups1,
        commodities1,
        companies2,
        fields2,
        industries2,
        groups2,
        commodities2,
        inputCategoryValues1,
        setInputCategoryValues1,
        inputCategoryValues2,
        setInputCategoryValues2,
      }}
    >
      {children}
    </DomesticMarketSpreadPriceCategoryContext.Provider>
  );
};

export default DomesticMarketSpreadPriceCategoryProvider;

export const useDomesticMarketSpreadPriceCategoryContext = () =>
  useContext(DomesticMarketSpreadPriceCategoryContext);
